import React from 'react'
import {
  IconCalendar,
  IconCircleDot,
  IconCircleDashedCheck,
  IconCircleCheckFilled,
  IconPhone,
  IconTag,
  IconUser,
  IconSparkles,
} from '@tabler/icons-react'
import moment from 'moment'

import { Divider } from '@/components/dividers/Divider'
import { Table } from '@/components/tables/Table/Table'
import { Pill } from '@/components/pills/Pill'
import { COACHING_TASK_TYPE } from '@/reducers/tasks/tasks.constants'

import { formatTaskStatus, formatTaskType } from './helpers'

export const Metadata = ({
  status,
  agent,
  type,
  createdAt,
  createdBy,
  isAiGenerated,
  agentReviewed,
  callDate,
}) => {
  const dataTestId = 'task-drawer-metadata'
  const createdStr = moment.utc(createdAt).local()

  const formattedTaskPill = () => {
    const taskType = formatTaskType(type, isAiGenerated)

    return (
      <Pill
        dataTestId={`${dataTestId}-task-type`}
        xs
        magical={taskType === 'AI'}
        warning={taskType === 'Pending Evaluation'}
        critical={taskType === 'Dispute'}
        informative={taskType.startsWith('Manual')}
        bold
        icon={taskType === 'AI' ? <IconSparkles /> : null}
      >
        {taskType}
      </Pill>
    )
  }

  return (
    <>
      <Table plain compact className="metadata-table" data-testid={dataTestId}>
        <tbody>
          <tr>
            <td>
              <div className="flex-align-center small-gap">
                <IconCircleDot className="icon-svg" />
                <strong>Status</strong>
              </div>
            </td>
            <td>
              <div className="flex-align-center small-gap" data-testid={`${dataTestId}-status`}>
                {status !== ('completed' || 'ignored') ? (
                  <IconCircleDashedCheck
                    className="icon-svg"
                    data-testid={`${dataTestId}-dashed-check`}
                  />
                ) : (
                  <IconCircleCheckFilled
                    data-testid={`${dataTestId}-filled-check`}
                    className="status-success"
                  />
                )}
                {formatTaskStatus(status)}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="flex-align-center small-gap">
                <IconUser className="icon-svg" />
                <strong>Agent</strong>
              </div>
            </td>
            <td data-testid={`${dataTestId}-agent`}>{agent}</td>
          </tr>
          {type === COACHING_TASK_TYPE && (
            <tr>
              <td>
                <div className="flex-align-center small-gap">
                  <IconUser className="icon-svg" />
                  <strong>Acknowledged</strong>
                </div>
              </td>
              <td data-testid={`${dataTestId}-agent-reviewed`}>
                <div className="flex-align-center small-gap" data-testid={`${dataTestId}-status`}>
                  {!agentReviewed ? (
                    <IconCircleDashedCheck
                      className="icon-svg"
                      data-testid={`${dataTestId}-dashed-check`}
                    />
                  ) : (
                    <IconCircleCheckFilled
                      data-testid={`${dataTestId}-filled-check`}
                      className="status-success"
                    />
                  )}
                  {!agentReviewed ? 'No' : 'Yes'}
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <div className="flex-align-center small-gap">
                <IconTag className="icon-svg" />
                <strong>Type</strong>
              </div>
            </td>
            <td>{formattedTaskPill()}</td>
          </tr>
          {callDate && (
            <tr>
              <td>
                <div className="flex-align-center small-gap">
                  <IconPhone className="icon-svg" />
                  <strong>Call Date</strong>
                </div>
              </td>
              <td data-testid={`${dataTestId}-call-date`}>
                {moment.utc(callDate).local().format('MM/DD/YYYY')}
              </td>
            </tr>
          )}
          <tr>
            <td>
              <div className="flex-align-center small-gap">
                <IconCalendar className="icon-svg" />
                <strong>Date Created</strong>
              </div>
            </td>
            <td data-testid={`${dataTestId}-date`}>{createdStr.format('MM/DD/YYYY')}</td>
          </tr>
          {createdBy && (
            <tr>
              <td>
                <div className="flex-align-center small-gap">
                  <IconUser className="icon-svg" />
                  <strong>Created By</strong>
                </div>
              </td>
              <td data-testid={`${dataTestId}-createdBy`}>
                {isAiGenerated ? 'Balto AI' : createdBy}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Divider />
    </>
  )
}
